/** Zeitangaben der Einstellungen: heute nur „heute 09:40“, sonst Tag und Uhrzeit, fremdes Jahr mit Jahr. */
export function stamp(iso: string | null | undefined, now = new Date()): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const time = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' }).format(
    date,
  );
  if (date.toDateString() === now.toDateString()) return `heute ${time}`;
  const day = new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    ...(date.getFullYear() === now.getFullYear() ? {} : { year: 'numeric' }),
  }).format(date);
  return `${day} ${time}`;
}
